import * as React from "react"

import {withTranslation, WithTranslation} from "react-i18next"

import {Button, Classes, Dialog, Intent, MenuItem} from "@blueprintjs/core"

import {ReactComponent as Logo} from "../../../img/biocrates_Logo_15mm_RGB.svg"
import env from "../../context/Env"

export interface AboutDialogState {
    isOpen: boolean
}

class AboutDialog extends React.Component<WithTranslation, AboutDialogState> {
    constructor(props: any) {
        super(props)
        this.state = {
            isOpen: false,
        }
    }

    private handleCancel = () => {
        this.setState({isOpen: false})
    }

    render() {
        const {t} = this.props

        return (
            <div>
                <MenuItem
                    className="MenuLink"
                    icon="document"
                    text="About"
                    shouldDismissPopover={false}
                    onClick={(e: any) => {
                        this.setState({isOpen: true})
                    }}
                />
                <Dialog
                    title="About"
                    icon="info-sign"
                    isOpen={this.state.isOpen}
                    onClose={this.handleCancel}
                >
                    <div className={Classes.DIALOG_BODY}>
                        <Logo width="200" />
                        <div style={{marginTop: "20px"}}>
                            {env("APPLICATION_NAME")} <br />
                            Copyright © {new Date().getFullYear()} biocrates
                            life sciences ag
                        </div>
                        <div style={{margin: "20px 0", fontSize: "12px"}}>
                            Imprint <br />
                            Authorized representative: Moritz Seuster, CEO
                            <br />
                            E-mail address:&nbsp;
                            <a href="mailto:office@biocrates.com">
                                office@biocrates.com
                            </a>
                            &nbsp;| Phone: +43512579823 <br />
                            Tax Identification Number: ATU56725128 <br />
                            Company Registration Number: 220414p <br />
                        </div>
                        <br />
                        <div>
                            <a
                                className="biocrates-big-action"
                                href={env("TERMS_AND_CONDITIONS_URL")}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {t("Terms & Conditions")}
                            </a>
                            <br />
                            <a
                                className="biocrates-big-action"
                                href={env("PRIVACY_POLICY_URL")}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {t("Privacy Policy")}
                            </a>
                            <br />
                            {env("EULA_LABEL") && env("EULA_URL") && (
                                <>
                                    <a
                                        className="biocrates-big-action"
                                        href={env("EULA_URL")}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {t(env("EULA_LABEL"))}
                                    </a>
                                    <br />
                                </>
                            )}
                            <a
                                className="biocrates-big-action"
                                href={env("THIRD_PARTY_LICENSES_URL")}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {t("Third-party licenses")}
                            </a>
                            <br />
                        </div>
                    </div>
                    <div className={Classes.DIALOG_FOOTER}>
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button
                                intent={Intent.DANGER}
                                onClick={this.handleCancel}
                            >
                                {t("Cancel")}
                            </Button>
                        </div>
                    </div>
                </Dialog>
            </div>
        )
    }
}

export default withTranslation()(AboutDialog)
